/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as RepoStrongRef from '../../../com/atproto/repo/strongRef.defs.js'

const $nsid = 'app.bsky.graph.follow'

export { $nsid }

/** Record declaring a social 'follow' relationship of another account. Duplicate follows will be ignored by the AppView. */
type Main = {
  $type: 'app.bsky.graph.follow'
  subject: l.DidString
  createdAt: l.DatetimeString
  via?: RepoStrongRef.Main
}

export type { Main }

/** Record declaring a social 'follow' relationship of another account. Duplicate follows will be ignored by the AppView. */
const main = l.record<'tid', Main>(
  'tid',
  $nsid,
  l.object({
    subject: l.string({ format: 'did' }),
    createdAt: l.string({ format: 'datetime' }),
    via: l.optional(
      l.ref<RepoStrongRef.Main>((() => RepoStrongRef.main) as any),
    ),
  }),
)

export { main }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main),
  $build = /*#__PURE__*/ main.build.bind(main),
  $type = /*#__PURE__*/ main.$type
export const $assert = /*#__PURE__*/ main.assert.bind(main),
  $check = /*#__PURE__*/ main.check.bind(main),
  $cast = /*#__PURE__*/ main.cast.bind(main),
  $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main),
  $matches = /*#__PURE__*/ main.matches.bind(main),
  $parse = /*#__PURE__*/ main.parse.bind(main),
  $safeParse = /*#__PURE__*/ main.safeParse.bind(main),
  $validate = /*#__PURE__*/ main.validate.bind(main),
  $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)
